export const CATEGORIES = [
  "Frutta e Verdura",
  "Latticini",
  "Carne",
  "Salumi",
  "Panetteria",
  "Pasta e Riso",
  "Conserve",
  "Bevande",
  "Surgelati",
  "Dolciario",
  "Pesce",
  "Altro",
];

export const CONF_STYLE = {
  alta: "bg-[#E8F3EC] text-[#2B5A3F] border-[#C5E1D1]",
  media: "bg-[#FDF6E3] text-[#8B6518] border-[#F2DEB0]",
  bassa: "bg-[#FCEAE8] text-[#8E3B2A] border-[#F2C4BE]",
};
